import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";
import { COMPANY, LOGO_URL } from "@/lib/brand";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#121413] text-white/80 mt-24"
    >
      <div className="grain" />
      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-black overflow-hidden ring-1 ring-white/10">
                <img
                  src={LOGO_URL}
                  alt="Lenax Pharmaceuticals"
                  className="w-12 h-12 object-cover"
                />
              </span>
              <div className="flex flex-col leading-none">
                <span className="font-serif text-2xl text-white">Lenax</span>
                <span className="overline text-[10px] text-white/60 mt-1">
                  Pharmaceuticals
                </span>
              </div>
            </div>
            <p className="mt-6 text-white/70 text-sm max-w-md leading-relaxed">
              {COMPANY.tagline}. We research, manufacture and distribute
              high-quality medicines that help clinicians and patients reach
              better outcomes — every single day.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="overline text-white/50">Navigate</p>
            <ul className="mt-5 space-y-3 text-sm">
              <li>
                <Link
                  to="/"
                  data-testid="footer-home-link"
                  className="hover:text-white transition-colors"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/products"
                  data-testid="footer-products-link"
                  className="hover:text-white transition-colors"
                >
                  Products
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  data-testid="footer-about-link"
                  className="hover:text-white transition-colors"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/career"
                  data-testid="footer-career-link"
                  className="hover:text-white transition-colors"
                >
                  Career
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="overline text-white/50">Reach Us</p>
            <ul className="mt-5 space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <MapPin size={16} className="text-[#1E8A2E] mt-0.5 shrink-0" />
                <span data-testid="footer-address">{COMPANY.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={16} className="text-[#1E8A2E] shrink-0" />
                <a
                  href={`mailto:${COMPANY.info_email}`}
                  data-testid="footer-email"
                  className="hover:text-white transition-colors"
                >
                  {COMPANY.info_email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10">
          <p className="font-serif text-[14vw] md:text-[10vw] leading-[0.85] text-white/[0.06] tracking-tight select-none pointer-events-none">
            Lenax Pharmaceuticals
          </p>
        </div>

        <div className="mt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-white/50">
          <p data-testid="footer-copyright">
            © {new Date().getFullYear()} {COMPANY.legal}. All rights reserved.
          </p>
          <p>For healthcare professionals & general public information only.</p>
        </div>
      </div>
    </footer>
  );
}
